module.exports = __webpack_public_path__ + "img/hc_05.9e990a9b.png";